import React from "react";
import { Typography } from "antd";
import { IProductsTitle } from "interfaces/ClientInterface/IProduct";

const { Title } = Typography;

const ProductTitle = (props: IProductsTitle) => {
  const { titleClass, titleText, textFontLevel } = props;

  return (
    <Title level={textFontLevel} className={titleClass} title={titleText}>
      {titleText}
    </Title>
  );
};

export default ProductTitle;
